import { useEffect, useState } from 'react'
import { Icon } from '@iconify/react'
import type { AppUpdateFoundDetail } from '../../features/pwa/appVersion'

export function AppUpdateNotice() {
  const [update, setUpdate] = useState<AppUpdateFoundDetail | null>(null)

  useEffect(() => {
    const handleUpdateFound = (event: Event) => {
      setUpdate((event as CustomEvent<AppUpdateFoundDetail>).detail)
    }
    window.addEventListener('pg19:app-update-found', handleUpdateFound)
    return () => window.removeEventListener('pg19:app-update-found', handleUpdateFound)
  }, [])

  if (!update) return null

  const versionLabel =
    update.next.version !== '0.0.0'
      ? update.next.version
      : update.next.gitSha

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed left-3 right-3 bottom-20 md:left-auto md:right-6 md:bottom-6 md:w-[360px] z-[70] app-update-notice"
      style={{
        paddingBottom: 'env(safe-area-inset-bottom, 0)',
      }}
    >
      <div className="liquid-glass-card p-4">
        <div className="flex items-start gap-3">
          <div
            className="shrink-0 flex items-center justify-center rounded-full"
            style={{
              width: 44,
              height: 44,
              background: 'linear-gradient(135deg, #F7941D, #E91E8C)',
              color: 'white',
              boxShadow: '0 8px 22px -6px rgba(247, 148, 29, 0.5)',
            }}
          >
            <Icon icon="heroicons:arrow-path" className="w-5 h-5" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-bold" style={{ color: 'var(--text-primary)' }}>
              Доступно обновление
            </p>
            <p className="text-xs mt-1" style={{ color: 'var(--text-muted)' }}>
              Версия {versionLabel}. Приложение обновится автоматически.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="btn btn-primary btn-sm mt-3 w-full"
            >
              Обновить сейчас
            </button>
          </div>
          <button
            type="button"
            onClick={() => setUpdate(null)}
            aria-label="Скрыть уведомление"
            className="shrink-0 inline-flex items-center justify-center rounded-full transition-all hover:bg-black/5 dark:hover:bg-white/10 active:scale-95"
            style={{ minWidth: 40, minHeight: 40, color: 'var(--text-muted)' }}
          >
            <Icon icon="heroicons:x-mark" className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  )
}
